import { h } from "preact";
import { route, RouterProps } from "preact-router";
import { useBodyStyle } from "../hooks";
import { Container } from "../material";
import "./confirmationpage.scss";
import { useEffect } from "preact/hooks";

export function ConfirmationPage(props: RouterProps) {
    useBodyStyle("material");

    useEffect(() => {
        if (sessionStorage.getItem("sent") !== "yes") {
            route("/");
            console.log("should have redirected")
        } else {
            sessionStorage.removeItem("sent");
        }
    });

    return (
        <Container class="grow column confirmationpage">
            <h1>Flexudlejning bekræftelse</h1>
            <a href="/">&lt;&lt; Tilbage til forsiden</a>
            <p>Din forespørgsel er sendt.</p>
        </Container>
    );
}
